import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
    const [scrolled, setScrolled] = useState(false);
    const [servicesOpen, setServicesOpen] = useState(false);
    const [industriesOpen, setIndustriesOpen] = useState(false);
    const [closeTimeout, setCloseTimeout] = useState(null);
    const [industriesTimeout, setIndustriesTimeout] = useState(null);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);


    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 100);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleMouseEnter = () => {
        if (closeTimeout) {
            clearTimeout(closeTimeout);
            setCloseTimeout(null);
        }
        setServicesOpen(true);
    };

    const handleMouseLeave = () => {
        const timeout = setTimeout(() => {
            setServicesOpen(false);
        }, 300); // 300ms delay before closing
        setCloseTimeout(timeout);
    };

    const handleIndustriesMouseEnter = () => {
        if (industriesTimeout) {
            clearTimeout(industriesTimeout);
            setIndustriesTimeout(null);
        }
        setIndustriesOpen(true);
    };

    const handleIndustriesMouseLeave = () => {
        const timeout = setTimeout(() => {
            setIndustriesOpen(false);
        }, 300); // 300ms delay before closing
        setIndustriesTimeout(timeout);
    };

    return (
        <header id="header" className={scrolled ? 'scrolled' : ''}>
            <div className="header-inner">
                <Link to="/" className="logo logo-image-link">
                    <img
                        src="/logo.png"
                        alt="Digi Network Logo"
                        style={{ height: '55px', width: 'auto', filter: 'brightness(0)', display: 'block' }}
                    />
                </Link>
                <nav>
                    <ul>
                        <li
                            className="dropdown"
                            onMouseEnter={handleMouseEnter}
                            onMouseLeave={handleMouseLeave}
                        >
                            <Link to="/services">
                                Services <span className="dropdown-arrow">▾</span>
                            </Link>
                            {servicesOpen && (
                                <div
                                    className="dropdown-menu"
                                    onMouseEnter={handleMouseEnter}
                                    onMouseLeave={handleMouseLeave}
                                >
                                    <div className="dropdown-section">
                                        <Link to="/services/seo" className="dropdown-title">
                                            🔍 SEO Services
                                        </Link>
                                        <Link to="/services/seo/on-page">On-Page SEO</Link>
                                        <Link to="/services/seo/off-page">Off-Page SEO</Link>
                                        <Link to="/services/seo/technical-seo">Technical SEO</Link>
                                        <Link to="/services/seo/link-building">Link Building</Link>
                                    </div>
                                    <div className="dropdown-section">
                                        <Link to="/services/paid-ads" className="dropdown-title">
                                            📈 Paid Advertising
                                        </Link>
                                        <Link to="/services/paid-ads/meta">Meta Ads</Link>
                                        <Link to="/services/paid-ads/google">Google Ads</Link>
                                        <Link to="/services/paid-ads/linkedin">LinkedIn Ads</Link>
                                        <Link to="/services/paid-ads/tiktok">TikTok Ads</Link>
                                    </div>
                                    <div className="dropdown-section">
                                        <Link to="/services/web-development" className="dropdown-title">
                                            💻 Web Development
                                        </Link>
                                        <Link to="/services/web-development/custom">Custom Websites</Link>
                                        <Link to="/services/web-development/wordpress">WordPress</Link>
                                        <Link to="/services/web-development/shopify">Shopify</Link>
                                        <Link to="/services/web-development/webflow">Webflow</Link>
                                    </div>
                                    <div className="dropdown-section">
                                        <Link to="#" className="dropdown-title">
                                            Other Services
                                        </Link>
                                        <Link to="/services/email-marketing">Email Marketing</Link>
                                        <Link to="/services/gohighlevel">GoHighLevel</Link>
                                    </div>
                                </div>
                            )}
                        </li>
                        <li
                            className="dropdown"
                            onMouseEnter={handleIndustriesMouseEnter}
                            onMouseLeave={handleIndustriesMouseLeave}
                        >
                            <Link to="/industries">
                                Industries <span className="dropdown-arrow">▾</span>
                            </Link>
                            {industriesOpen && (
                                <div
                                    className="dropdown-menu industries-menu"
                                    onMouseEnter={handleIndustriesMouseEnter}
                                    onMouseLeave={handleIndustriesMouseLeave}
                                >
                                    <Link to="/industries/healthcare" className="industry-link">
                                        <h4>Healthcare</h4>
                                    </Link>
                                    <Link to="/industries/real-estate" className="industry-link">
                                        <h4>Real Estate</h4>
                                    </Link>
                                    <Link to="/industries/e-commerce" className="industry-link">
                                        <h4>E-commerce</h4>
                                    </Link>
                                    <Link to="/industries/legal" className="industry-link">
                                        <h4>Legal Services</h4>
                                    </Link>
                                    <Link to="/industries/fitness" className="industry-link">
                                        <h4>Fitness & Wellness</h4>
                                    </Link>
                                    <Link to="/industries/saas" className="industry-link">
                                        <h4>SaaS</h4>
                                    </Link>
                                    <Link to="/industries/dental" className="industry-link">
                                        <h4>Dental</h4>
                                    </Link>
                                    <Link to="/industries/automotive" className="industry-link">
                                        <h4>Automotive</h4>
                                    </Link>
                                    <Link to="/industries/hospitality" className="industry-link">
                                        <h4>Hospitality</h4>
                                    </Link>
                                    <Link to="/industries/education" className="industry-link">
                                        <h4>Education</h4>
                                    </Link>
                                    <Link to="/industries/financial" className="industry-link">
                                        <h4>Financial Services</h4>
                                    </Link>
                                    <Link to="/industries/home-services" className="industry-link">
                                        <h4>Home Services</h4>
                                    </Link>
                                </div>
                            )}
                        </li>
                        <li>
                            <Link to="/blog">Blog</Link>
                        </li>
                        <li>
                            <Link to="/case-studies">Case Studies</Link>
                        </li>
                        <li>
                            <Link to="/about">About</Link>
                        </li>
                        <li>
                            <Link to="/contact" className="btn btn-primary">
                                Get Started
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </Link>
                        </li>
                    </ul>
                </nav>
                <button
                    className="mobile-menu-toggle"
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                    aria-label="Toggle menu"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </div>

            {/* Mobile Menu */}
            <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
                <nav className="mobile-nav">
                    <Link to="/" onClick={() => setMobileMenuOpen(false)}>Home</Link>

                    <div className="mobile-dropdown">
                        <span className="mobile-dropdown-title">Services</span>
                        <div className="mobile-dropdown-content">
                            <Link to="/services" onClick={() => setMobileMenuOpen(false)}>All Services</Link>
                            <div className="mobile-service-group">
                                <span className="mobile-service-label">SEO Services</span>
                                <Link to="/services/seo" onClick={() => setMobileMenuOpen(false)}>SEO Overview</Link>
                                <Link to="/services/seo/on-page" onClick={() => setMobileMenuOpen(false)}>On-Page SEO</Link>
                                <Link to="/services/seo/off-page" onClick={() => setMobileMenuOpen(false)}>Off-Page SEO</Link>
                                <Link to="/services/seo/technical-seo" onClick={() => setMobileMenuOpen(false)}>Technical SEO</Link>
                                <Link to="/services/seo/link-building" onClick={() => setMobileMenuOpen(false)}>Link Building</Link>
                            </div>
                            <div className="mobile-service-group">
                                <span className="mobile-service-label">Paid Advertising</span>
                                <Link to="/services/paid-ads" onClick={() => setMobileMenuOpen(false)}>Paid Ads Overview</Link>
                                <Link to="/services/paid-ads/meta-ads" onClick={() => setMobileMenuOpen(false)}>Meta Ads</Link>
                                <Link to="/services/paid-ads/google-ads" onClick={() => setMobileMenuOpen(false)}>Google Ads</Link>
                                <Link to="/services/paid-ads/linkedin-ads" onClick={() => setMobileMenuOpen(false)}>LinkedIn Ads</Link>
                                <Link to="/services/paid-ads/tiktok-ads" onClick={() => setMobileMenuOpen(false)}>TikTok Ads</Link>
                            </div>
                            <div className="mobile-service-group">
                                <span className="mobile-service-label">Web Development</span>
                                <Link to="/services/web-development" onClick={() => setMobileMenuOpen(false)}>Web Dev Overview</Link>
                                <Link to="/services/web-development/custom-development" onClick={() => setMobileMenuOpen(false)}>Custom Websites</Link>
                                <Link to="/services/web-development/wordpress-development" onClick={() => setMobileMenuOpen(false)}>WordPress</Link>
                                <Link to="/services/web-development/shopify" onClick={() => setMobileMenuOpen(false)}>Shopify</Link>
                                <Link to="/services/web-development/webflow-development" onClick={() => setMobileMenuOpen(false)}>Webflow</Link>
                            </div>
                            <div className="mobile-service-group">
                                <span className="mobile-service-label">Email Marketing</span>
                                <Link to="/services/email-marketing" onClick={() => setMobileMenuOpen(false)}>Email Marketing</Link>
                                <Link to="/services/email-marketing" onClick={() => setMobileMenuOpen(false)}>Marketing Automation</Link>
                            </div>
                            <div className="mobile-service-group">
                                <span className="mobile-service-label">GoHighLevel</span>
                                <Link to="/services/gohighlevel" onClick={() => setMobileMenuOpen(false)}>GoHighLevel</Link>
                                <Link to="/services/gohighlevel" onClick={() => setMobileMenuOpen(false)}>CRM & Automation</Link>
                            </div>
                        </div>
                    </div>

                    <div className="mobile-dropdown">
                        <span className="mobile-dropdown-title">Industries</span>
                        <div className="mobile-dropdown-content">
                            <Link to="/industries/healthcare" onClick={() => setMobileMenuOpen(false)}>Healthcare</Link>
                            <Link to="/industries/real-estate" onClick={() => setMobileMenuOpen(false)}>Real Estate</Link>
                            <Link to="/industries/e-commerce" onClick={() => setMobileMenuOpen(false)}>E-commerce</Link>
                            <Link to="/industries/legal" onClick={() => setMobileMenuOpen(false)}>Legal Services</Link>
                            <Link to="/industries/fitness" onClick={() => setMobileMenuOpen(false)}>Fitness & Wellness</Link>
                            <Link to="/industries/saas" onClick={() => setMobileMenuOpen(false)}>SaaS</Link>
                            <Link to="/industries/dental" onClick={() => setMobileMenuOpen(false)}>Dental</Link>
                            <Link to="/industries/automotive" onClick={() => setMobileMenuOpen(false)}>Automotive</Link>
                            <Link to="/industries/hospitality" onClick={() => setMobileMenuOpen(false)}>Hospitality</Link>
                            <Link to="/industries/education" onClick={() => setMobileMenuOpen(false)}>Education</Link>
                            <Link to="/industries/financial" onClick={() => setMobileMenuOpen(false)}>Financial Services</Link>
                            <Link to="/industries/home-services" onClick={() => setMobileMenuOpen(false)}>Home Services</Link>
                        </div>
                    </div>

                    <Link to="/blog" onClick={() => setMobileMenuOpen(false)}>Blog</Link>
                    <Link to="/case-studies" onClick={() => setMobileMenuOpen(false)}>Case Studies</Link>
                    <Link to="/about" onClick={() => setMobileMenuOpen(false)}>About</Link>
                    <Link to="/contact" className="btn btn-primary" onClick={() => setMobileMenuOpen(false)}>
                        Get Started
                    </Link>
                </nav>
            </div>
        </header>
    );
};

export default Header;